import * as CONSTANTS from './constants';

declare global {
    interface Window {
        grecaptcha: {
            ready: (cb: () => void) => void;
            execute: (siteKey: string, options: { action: string }) => Promise<string>;
        };
    }
}

const RECAPTCHA_SITE_KEY = CONSTANTS.RECAPTCHA_SITE_KEY;

/** Injects the reCAPTCHA v3 script. Call once at app startup. */
export function initRecaptcha(): void {
    if (!RECAPTCHA_SITE_KEY) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    document.head.appendChild(script);
}

/** Execute reCAPTCHA and return a token. Returns empty string on any failure. */
export function executeRecaptcha(action: string): Promise<string> {
    return new Promise((resolve) => {
        if (!RECAPTCHA_SITE_KEY) return resolve('');

        const waitForGrecaptcha = (retries = 50) => {
            if (window.grecaptcha) {
                window.grecaptcha.ready(async () => {
                    try {
                        const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
                        resolve(token);
                    } catch {
                        resolve('');
                    }
                });
            } else if (retries > 0) {
                setTimeout(() => waitForGrecaptcha(retries - 1), 100);
            } else {
                resolve('');
            }
        };

        waitForGrecaptcha();
    });
}